module.exports = __webpack_public_path__ + "static/img/inventario_plataformas.7bd7e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_plataformas.png
// module id = 96
// module chunks = 0